





































import Vue from 'vue'
import api from '@/api'
import store from '@/store'
import TextInput from '@/components/TextInput.vue'

export default Vue.extend({
  name: 'Contact',

  components: {
    TextInput,
  },

  data: () => ({
    message: {
      name: '',
      email: '',
      body: '',
    },
    showConfirmation: false,
    store,
  }),

  methods: {
    handleInputChange(name: string, value: string) {
      this.message = { ...this.message, [name]: value }
    },

    async submit(e: Event) {
      e.preventDefault()
      try {
        await api.sendContactMsg(this.message.name, this.message.email, this.message.body)
        this.showConfirmation = true
      } catch (err) {
        this.store.setErrorMessage('Could not send message')
      }
    },
  },
})
